<template>
  <div class="content-order-form">
    <div class="form-header">
      <h2>Order Copies for Students</h2>
      <div class="header-content">
        <div class="content-info">
          <img 
            v-if="contentInfo.cover_url" 
            :src="contentInfo.cover_url" 
            class="content-cover"
            alt="Content cover"
          />
          <div class="content-text">
            <span class="content-type" :class="contentInfo.type">{{ contentInfo.type }}</span>
            <span class="content-title">{{ contentInfo.title }}</span>
            <span class="content-price">{{ contentInfo.usd_price === 0 ? 'FREE' : '$' + contentInfo.usd_price }}</span>
          </div>
        </div>
        
        <div class="form-actions">
          <div class="total-copies">
            <span class="total-copies-label">Select Club:</span>
            <el-select 
              v-model="selectedClub" 
              placeholder="Select a club"
              style="width: 250px;"
              :required="true"
            >
              <el-option
                v-for="club in clubList"
                :key="club._id.$id"
                :label="club.name"
                :value="club._id.$id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="total-copies">
            <span class="total-copies-label">Total Copies to Order:</span>
            <div class="add-copies">
              <el-input-number
                v-model="total_copies"
                :min="1"
                :max="20"
                size="small"
                style="width: 120px;"
              ></el-input-number>
            </div>
          </div>
          <div class="total-copies">
            <span class="total-copies-label">Total Price:</span>
            <span>${{ contentInfo.usd_price * total_copies }}</span>
          </div>
          
          <el-button type="primary" @click="submitOrder" :loading="submitting">
            Submit Order
          </el-button>
        </div>
      </div>
    </div>

    

    <div class="form-footer">
      <div class="footer-content">
        <div class="total-copies">
          <div class="total-copies-content">
            
            
          </div>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub';
import { getUserId } from '@/utils/store';
export default {
  name: 'ContentOrderForm',
  data() {
    return {
      contentInfo: {
        title: '',
        type: '',
        cover_url: '',
        usd_price: 0,
        content_id: ''
      },
      total_copies: 1,
      submitting: false,
      clubList: [],
      selectedClub: '',
      
    }
  },
  async created() {
    // Get content info from route query
    this.contentInfo = {
      title: this.$route.query.title,
      type: this.$route.query.type,
      cover_url: this.$route.query.cover_url,
      usd_price: this.$route.query.usd_price,
      content_id: this.$route.query.content_id
    }
    
    await this.fetchClubList();
    console.log(this.contentInfo)
  },
  methods: {
    async fetchClubList() {
      try {
        const response = await postRequest('getAdvisorClubs', {
          advisor_id: getUserId()
        });
        
        if (response.data.code === 0) {
          this.clubList = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching club list:', error);
        this.$message.error('Failed to fetch club list');
      }
    },
    async submitOrder() {
      // Add validation checks
      if (!this.selectedClub) {
        this.$message.warning('Please select a club');
        return;
      }

      if (!this.total_copies || this.total_copies <= 0) {
        this.$message.warning('Please enter a valid quantity greater than 0');
        return;
      }
      
      try {
        this.submitting = true
        const response = await postRequest('submitContentOrder', {
          content_id: this.$route.query.content_id,
          quantity: this.total_copies,
          contact_id: getUserId(),
          club_id: this.selectedClub,
          content_type: this.contentInfo.type,
          total_price: this.contentInfo.usd_price * this.total_copies,
          content_info: {
            title: this.contentInfo.title,
            cover_url: this.contentInfo.cover_url
          },
          usd_price: this.contentInfo.usd_price,
          club_id: this.selectedClub,
          
          
        })
        
        if (response.data.code === 0) {
          const result = response.data.data
          if (result.status === 'PENDING') {
            this.$router.push({
              name: 'Content Payment',
              query: { order_id: result._id.$id }
            })
          } else if (result.status === 'COMPLETED') {
            const selectedClubInfo = this.clubList.find(club => club._id.$id === this.selectedClub);
            this.$router.push({
              name: 'Content Copy',
              query: { 
                content_id: this.$route.query.content_id,
                club_id: this.selectedClub,
                club_name: selectedClubInfo?.name || ''
              }
            })
          }
        }
      } catch (error) {
        console.error('Error submitting order:', error)
        this.$message.error('Failed to submit order')
      } finally {
        this.submitting = false
      }
    },
    async submitOrderToAPI() {
      // TODO: Implement actual API call
      const orderData = {
        contact_id: getUserId(),
        content_id: this.contentInfo.content_id,
        content_type: this.contentInfo.type,
        content_info: {
          title: this.contentInfo.title,
          cover_url: this.contentInfo.cover_url
        },
        quantity: this.total_copies,
        total_price: this.contentInfo.usd_price * this.total_copies
      };

      const response = await postRequest('submitContentOrder', orderData);
      
      if (response.data.code !== 0) {
        throw new Error(response.data.message || 'Failed to submit order');
      }

      return response.data.data;
      
    }
  }
}
</script>

<style lang="scss" scoped>
.content-order-form {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;

  .form-header {
    margin-bottom: 32px;

    h2 {
      margin: 0 0 24px;
      color: #303133;
      font-size: 24px;
    }

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 32px;
      
      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    .content-info {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      padding: 20px;
      border: 1px solid #dcdfe6;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      width: 100%;
      max-width: 500px;

      .content-cover {
        width: 120px;
        height: 165px;
        object-fit: cover;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .content-text {
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex: 1;

        .content-price {
          font-size: 16px;
          font-weight: 600;
          color: #409eff;
        }

        .content-title {
          font-size: 20px;
          font-weight: 500;
          color: #303133;
          line-height: 1.4;
        }

        .content-type {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 500;
          text-transform: capitalize;
          width: fit-content;

          &.events {
            background-color: #f0f9eb;
            color: #67c23a;
          }

          &.posts {
            background-color: #fdf6ec;
            color: #e6a23c;
          }

          &.achievements {
            background-color: #ecf5ff;
            color: #409eff;
          }
        }
      }
    }
  }

  .form-actions {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    flex: 1;

    .total-copies {
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .total-copies-label {
        font-size: 15px;
        color: #606266;
        font-weight: 500;
        min-width: 140px;
      }
    }

    .el-button {
      align-self: flex-end;
      padding: 12px 24px;
      font-size: 16px;
      margin-top: 8px;
    }
  }

  .form-footer {
    margin-top: 32px;
    
    .footer-content {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 24px;

      .total-copies {
        display: flex;
        align-items: center;
        
        .total-copies-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .total-copies-label {
          font-size: 15px;
          color: #606266;
          font-weight: 500;
        }
      }
    }
  }
}
</style> 